import React, { useContext } from 'react';
import { useBanners } from '../hooks';
import { BannerEntity } from '../types';

export interface FrameState {
  frames: BannerEntity[];
}

export interface FrameProviderProps {
  children: React.ReactNode;
}

const initialState: FrameState = {
  frames: [],
};

const FrameStateContext = React.createContext<FrameState>(initialState);

export const FrameProvider: React.FunctionComponent<FrameProviderProps> = ({
  children,
}: FrameProviderProps) => {
  const { banners: listFrames } = useBanners('frame');

  return (
    <FrameStateContext.Provider
      value={{
        frames: listFrames,
      }}
    >
      {children}
    </FrameStateContext.Provider>
  );
};

export function useFrame(): FrameState {
  const context = useContext(FrameStateContext);
  if (!context) {
    throw new Error(
      'useFrame must be inside a FrameStateContext with a state value',
    );
  }
  return context;
}
